import * as Sentry from '@sentry/react';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 40px;
  text-align: center;
`;

const ErrorTitle = styled.h2`
  color: #e74c3c;
  margin-bottom: 16px;
`;

const ErrorMessage = styled.p`
  color: #666;
  margin-bottom: 24px;
`;

const ReloadButton = styled.button`
  background: #276fdb;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #1e5bb3;
  }
`;

const ErrorFallback = ({ error }: { error: unknown }) => (
  <ErrorContainer>
    <ErrorTitle>Oops! Something went wrong</ErrorTitle>
    <ErrorMessage>
      We've been notified and are working on fixing this issue.
    </ErrorMessage>
    <ReloadButton onClick={() => window.location.reload()}>
      Reload Page
    </ReloadButton>
    {import.meta.env.DEV && (
      <details style={{ marginTop: '20px', textAlign: 'left' }}>
        <summary>Error details</summary>
        <pre style={{ whiteSpace: 'pre-wrap' }}>
          {error instanceof Error ? error.toString() : String(error)}
        </pre>
      </details>
    )}
  </ErrorContainer>
);

interface SentryErrorBoundaryProps {
  children: ReactNode;
}

const SentryErrorBoundary = ({ children }: SentryErrorBoundaryProps) => {
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default SentryErrorBoundary;
